import { useState } from 'react';

interface IProps {
  className?: string;
  label: string;
  value?: string;
  checked?: boolean;
  handleOnChange(label: string): void;
}

const Checkbox = ({
  checked,
  className,
  handleOnChange,
  label,
  value,
}: IProps) => {
  const [internalIsChecked, setInternalIsChecked] = useState(false);
  const isControlled = typeof checked === 'boolean';
  const isChecked = isControlled ? checked : internalIsChecked;
  const checkboxValue = value ?? label;

  const toggleCheckboxChange = () => {
    if (!isControlled) {
      setInternalIsChecked(!internalIsChecked);
    }

    handleOnChange(checkboxValue);
  };

  return (
    <div className={className}>
      <label>
        <input
          type="checkbox"
          value={checkboxValue}
          checked={isChecked}
          onChange={toggleCheckboxChange}
          data-testid="checkbox"
        />

        <span className="checkmark">{label}</span>
      </label>
    </div>
  );
};

export default Checkbox;
